import { useCallback } from 'react';

import { usePostHog } from 'posthog-js/react';
import { useInterval } from 'react-use';

export const useFeatureFlagRefresh = (refreshInterval = 10000) => {
  const posthog = usePostHog();

  const refreshFeatureFlag = useCallback(() => {
    if (!posthog) return;

    posthog.reloadFeatureFlags();
  }, [posthog]);

  useInterval(refreshFeatureFlag, refreshInterval);
};
